/* Trỏ 48 ảnh của quiz về kho asset phẳng của Shopify.
 *
 * VÌ SAO. Bản quiz bê nguyên dựng đường dẫn ảnh dạng TƯƠNG ĐỐI — `assets/box/...`,
 * `assets/solutions/...`, `assets/chakra-map-*.png`. Đường đó đúng ở bản Cloudflare (ảnh nằm
 * cạnh file HTML) nhưng trên theme thì trang là `/pages/quiz`, nên nó nở thành
 * `/pages/assets/...` → 404. Kho `assets/` của Shopify lại PHẲNG, không có thư mục con.
 *
 * LUẬT ĐẶT TÊN (một luật cho cả ba thư mục):
 *     assets/<đường>            →  qz-<đường, thay "/" bằng "-">
 *     assets/box/x.jpg          →  qz-box-x.jpg
 *     assets/solutions/y.jpg    →  qz-solutions-y.jpg
 *     assets/chakra-map-en.png  →  qz-chakra-map-en.png
 *
 * BỐN chỗ dựng đường dẫn, đã grep hết chứ không đoán:
 *     boxImg()        quiz-inner-weather.js:28102   trả về ĐƯỜNG DẪN trần
 *     v10sSolIcon()   :24782                        trả về HTML  (báo cáo)
 *     m11SolImg()     :27279                        trả về HTML  (bản đồ)
 *     v10rBodyMap()   :24623                        trả về HTML  (bản đồ luân xa)
 *
 * CÁCH VÁ. Ba hàm trả HTML thì BỌC hàm gốc rồi sửa chuỗi trả về — không chép lại khuôn
 * markup của chúng. Chép khuôn là tự nhận nợ: bản v3 đổi markup thì vá này im lặng phục vụ
 * bản cũ. Riêng `boxImg` trả đường dẫn trần nên đè thẳng.
 *
 * Kèm một lưới an toàn `MutationObserver` cho chỗ nào còn sót mà grep chưa thấy. Lưới đặt
 * SAU phần bọc chứ không thay nó: bọc chặn được cú gọi ảnh 404 ngay từ đầu, lưới thì chỉ sửa
 * sau khi thẻ đã vào DOM (đã kịp bắn một request hỏng).
 *
 * PHẢI đứng SAU `quiz-inner-weather.js`. Cả hai thẻ đều `defer` nên chạy theo thứ tự tài
 * liệu, và xong hết mới tới `DOMContentLoaded` — nơi quiz gọi `boot()`. Đảo thứ tự là vá rơi
 * vào khoảng không, không lỗi nào báo.
 */
(function () {
  var goc = document.getElementById('phone');
  if (!goc) return;

  /* Gốc CDN lấy từ Liquid: `asset_url` của một ảnh có thật, cắt bỏ phần tên file.
     Không ghép tay vì đường dẫn mang mã theme (`/t/5/`) đổi theo từng bản theme. */
  var GOC = (goc.getAttribute('data-goc-anh') || '').trim();
  if (!GOC) return;

  /* `assets/box/x.jpg` -> `<GOC>qz-box-x.jpg`. Trả nguyên đầu vào nếu không khớp.
     ĐỔI HAI LẦN PHẢI RA CÙNG MỘT KẾT QUẢ. Trên theme thì GOC là `//cdn…/assets/` nên
     chuỗi đã đổi không còn khớp `^assets/`; nhưng ở bàn thử cục bộ GOC chính là `assets/`,
     và lưới quan sát đã sửa chồng một lần nữa thành `qz-qz-…`. Chốt `qz-` ở đây để cái
     bẫy đó không quay lại ở bất kỳ cấu hình nào. */
  function doi(duong) {
    if (typeof duong !== 'string') return duong;
    var m = /^assets\/(.+)$/.exec(duong);
    if (!m) return duong;
    if (m[1].indexOf('qz-') === 0) return duong;
    return GOC + 'qz-' + m[1].split('/').join('-');
  }

  /* Sửa mọi `src="assets/…"` nằm trong một chuỗi HTML.
     PHẢI đi qua `doi()` chứ không tự ghép lại: `v10sSolIcon` gọi `v12bHopSrc()` → `boxImg()`,
     mà `boxImg` đã bị đè ở dưới, nên chuỗi trả về ĐÃ đúng rồi. Bản đầu tự ghép nên đổi lần
     hai thành `qz-qz-box-…` và ảnh bộ hộp chết — bàn thử bắt được, đúng 1 trong 9 ảnh. */
  function suaHtml(html) {
    if (typeof html !== 'string') return html;
    return html.replace(/(\ssrc=")(assets\/[^"]+)(")/g, function (_, dau, duong, cuoi) {
      return dau + doi(duong) + cuoi;
    });
  }

  /* Bọc một hàm toàn cục trả về HTML. */
  function boc(ten) {
    var g = window[ten];
    if (typeof g !== 'function') return false;
    window[ten] = function () {
      return suaHtml(g.apply(this, arguments));
    };
    return true;
  }

  if (typeof window.boxImg === 'function') {
    var boxImgGoc = window.boxImg;
    window.boxImg = function (ten) { return doi(boxImgGoc(ten)); };
  }

  boc('v10sSolIcon');
  boc('m11SolImg');
  boc('v10rBodyMap');

  /* Lưới an toàn: thẻ ảnh nào lọt vào DOM mà còn đường dẫn tương đối thì sửa tại chỗ. */
  function suaThe(im) {
    if (!im || im.getAttribute('data-qz')) return;
    var s = im.getAttribute('src') || '';
    if (s.indexOf('assets/') !== 0) return;
    im.setAttribute('data-qz', '1');
    im.setAttribute('src', doi(s));
  }
  function quet(goc_node) {
    var ds = goc_node.querySelectorAll ? goc_node.querySelectorAll('img[src^="assets/"]') : [];
    for (var i = 0; i < ds.length; i++) suaThe(ds[i]);
  }
  quet(document);
  if (window.MutationObserver) {
    new MutationObserver(function (ds) {
      for (var i = 0; i < ds.length; i++) {
        var them = ds[i].addedNodes;
        for (var j = 0; j < them.length; j++) {
          var n = them[j];
          if (n.nodeType !== 1) continue;
          if (n.tagName === 'IMG') suaThe(n);
          quet(n);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
